module.exports = __webpack_public_path__ + "static/media/3.62a781c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3.jpg
// module id = 25
// module chunks = 0